import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import 'moment-timezone';
import { APICallerService } from '../../services/api-caller/api-caller.service';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { MultipleDatePickerComponent } from '../multiple-date-picker/multiple-date-picker.component';
declare var $: any;

@Component({
  selector: 'app-edit-date-time-modal',
  templateUrl: './edit-date-time-modal.component.html',
  styleUrls: ['./edit-date-time-modal.component.scss'],
  standalone: false
})
export class EditDateTimeModalComponent implements OnInit {
  private spinner: SpinnerComponent | null = null;
  private apicaller = inject(APICallerService);
  public activeModal = inject(NgbActiveModal);
  private datePipe = inject(DatePipe);

  /** Orders API base URL (e.g. environment.wayOrdersUrl). Set by the opener when opening the modal. */
  wayOrdersUrl = '';

  selectedEndTime: string = '00:00:00';
  dateTimeObjToUpdate: any;
  selectedStartTime: string = '00:00:00';
  selectedStartTimeToShow: string = '12:00 AM';
  selectedEndTimeToShow: string = '12:00 AM';
  orderObjToUpdateTime: any;
  endTimeArray: any = [];
  cartData: any;
  order: any;
  startDateObj: any = {
    year: moment().year(),
    month: moment().month(),
    day: 1
  };
  errorEndDate: boolean = false;
  permission: any = [];
  startDate: any;
  endDate: any;

  showTimeList: boolean = false;
  showTimeListTo: boolean = false;
  today: any;
  checkintoday: any;
  checkOuttoday: any;
  checkOutDate: any;
  checkInDate: any;
  public disableDaysBefore = moment.now().valueOf();
  public highlightDays: Array<any> = [];
  public highlightDaysCheckout: Array<any> = [];
  public startDateModel: any;
  public endDateModel: any;
  selectedDays: any[] = [];
  selectedDaysCheckOut: any[] = [];
  dateSelectedMonth: any;
  dateSelectedMonthCheckout: any;
  selectedCheckinTime: any;
  selectedCheckoutTime: any;
  timeZone: any = moment.tz.guess();
  @ViewChild(MultipleDatePickerComponent) public multipleDatePicker!: MultipleDatePickerComponent;

  ngOnInit() {
    this.endTimeArray = this.timeArray;
    this.errorMessage = '';

    this.orderObjToUpdateTime = this.order;
    const dateTimeObj = this.order?.orderGroupItems?.[0];
    this.dateTimeObjToUpdate = dateTimeObj;

    if (!dateTimeObj) return;

    this.selectedStartTimeToShow = this.getDsplyByValue(this.extractTimeFromDateTime(dateTimeObj.startDateTime));
    this.selectedEndTimeToShow = this.getDsplyByValue(this.extractTimeFromDateTime(dateTimeObj.endDateTime));

    this.selectedStartTime = this.extractTimeFromDateTime(dateTimeObj.startDateTime);
    this.selectedEndTime = this.extractTimeFromDateTime(dateTimeObj.endDateTime);

    this.startDate = dateTimeObj.startDateTime.split(' ')[0];
    this.endDate = dateTimeObj.endDateTime.split(' ')[0];

    const momentDate = moment(this.startDate);
    const momentEndDate = moment(this.endDate);

    const formattedEndDate = momentEndDate.tz(this.timeZone).format('ddd MMM DD YYYY HH:mm:ss Z');
    const formattedDate = momentDate.tz(this.timeZone).format('ddd MMM DD YYYY HH:mm:ss Z');

    this.startDateModel = formattedDate;
    this.endDateModel = formattedEndDate;
    this.onDateTimeRespond();
  }

  close() {
    this.activeModal.close('close');
  }

  extractTimeFromDateTime(dateTimeString: string): string {
    const parts = dateTimeString.split(' ');
    const timePart = parts[1];
    return timePart ? timePart : '';
  }

  updateDateTimeWithNew() {
    this.timeStamptoDateConversion(this.startDateModel, 'from');
    this.timeStamptoDateConversion(this.endDateModel, 'to');

    const ordrObj = {
      orderId: this.cartData.orderId,
      orderType: this.cartData.orderType,
      isSingleItemCheckout: true,
      previousOrderGroupItemId: this.dateTimeObjToUpdate.orderGroupItemId,
      orderGroups: [
        {
          listing: {
            listingId: this.orderObjToUpdateTime.listing.listingId,
            serviceType: this.orderObjToUpdateTime.listing.serviceType
          },
          orderGroupItems: [
            {
              startDateTime: this.startDate + ' ' + this.selectedStartTime,
              endDateTime: this.endDate + ' ' + this.selectedEndTime,
              itemId: this.orderObjToUpdateTime.orderGroupItems[0].itemId,
              quantity: this.orderObjToUpdateTime.orderGroupItems[0].quantity
            }
          ]
        }
      ]
    };

    // this.spinner.show();
    const checkoutUrl = (this.wayOrdersUrl || '').replace(/\/$/, '') + '/public/cart?orderId=' + this.cartData.orderId;
    this.apicaller.postCall(checkoutUrl, ordrObj, true).subscribe(
      (data: any) => {
        localStorage.setItem('orderId', data.orderId);
        // this.spinner.hide();
        this.activeModal.close();
      },
      (err: any) => {
        // this.spinner.hide();
        this.errorMessage = err?.error?.message || 'An error occurred';
      }
    );
  }

  timeStamptoDateConversion(timestamp: any, type: string) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    if (type === 'from') this.startDate = `${year}-${month}-${day}`;
    else this.endDate = `${year}-${month}-${day}`;
  }

  errorTime: boolean = false;
  errorMessage = '';

  selectTime(selectedValue: any, type: string) {
    if (type === 'from') {
      this.selectedStartTimeToShow = selectedValue.dsply;
      this.selectedStartTime = selectedValue.value;
      this.showTimeList = false;
      this.validateDateAndTime(this.startDateModel, this.endDateModel);
    } else if (type === 'to') {
      this.selectedEndTimeToShow = selectedValue.dsply;
      this.selectedEndTime = selectedValue.value;
      this.showTimeListTo = false;
      this.validateDateAndTime(this.startDateModel, this.endDateModel);
    }
  }

  public getValueByDsply(dsply: string): string {
    const found = this.timeArray.find((item: any) => item.dsply === dsply);
    return found ? found.value : '';
  }

  public getDsplyByValue(value: string): string {
    const found = this.timeArray.find((item: any) => item.value === value);
    return found ? found.dsply : '';
  }

  toggleListVisibility(type: string) {
    if (type === 'from') {
      this.showTimeList = !this.showTimeList;
      this.scrollToSelectedCheckInTime();
    } else if (type === 'to') {
      this.showTimeListTo = !this.showTimeListTo;
      this.scrollToSelectedChecoutTime();
    }
  }

  scrollToSelectedCheckInTime() {
    setTimeout(() => {
      const index = this.timeArray.findIndex((time: any) => time.value === this.selectedStartTime);
      const selectedItem = document.querySelector('#prctm' + index);
      if (selectedItem && typeof $ !== 'undefined') {
        const container = $('#tpl');
        if (container.length) {
          const containerHeight = container.height();
          const itemTop = $(selectedItem).position().top;
          const scrollTo = itemTop - containerHeight / 2;
          container.scrollTop(scrollTo);
        }
      }
    });
  }

  scrollToSelectedChecoutTime() {
    setTimeout(() => {
      const index = this.endTimeArray.findIndex((time: any) => time.value === this.selectedEndTime);
      const selectedItem = document.querySelector('#prct' + index);
      if (selectedItem && typeof $ !== 'undefined') {
        const container = $('#tpl');
        if (container.length) {
          const containerHeight = container.height();
          const itemTop = $(selectedItem).position().top;
          const scrollTo = itemTop - containerHeight / 2;
          container.scrollTop(scrollTo);
        }
      }
    });
  }

  onDocumentClick(event: MouseEvent, ibox: string, type: string) {
    const inputBox = document.querySelector('.' + ibox);
    const dropdown = document.querySelector('.' + type);
    if (!inputBox || !dropdown) return;
    if (!(inputBox.contains(event.target as Node) || dropdown.contains(event.target as Node))) {
      if (type === 'checkin') {
        this.showTimeList = false;
        if (this.isCheckIn) this.isCheckIn = false;
      } else if (type === 'checkout') {
        this.showTimeListTo = false;
        if (this.isCheckOut) this.isCheckOut = false;
      }
    }
  }

  onDaySelect = (event: any, day: any) => {
    if (!day?.selectable) return;
    this.errorMessage = '';
    if (this.isCheckIn) {
      const diff = moment(day.date).diff(this.checkOuttoday ? this.checkOuttoday : moment(this.endDateModel, 'YYYY-MM-DD'), 'd');
      if (diff > 0) {
        event.preventDefault();
        this.setDateIfInvalid(day);
        return;
      }
      this.startDateModel = '';
      this.selectedDays = [];
      this.checkInDate = day.date._d;
      this.checkintoday = day.date._d;
      this.startDateModel = day.date;
      this.validateDateAndTime(this.startDateModel, this.endDateModel);
      this.isCheckIn = false;
      this.isCheckOut = false;
      this.selectedDays.push(day.date);
      this.dateSelectedMonth = moment(this.checkInDate, 'months', true);
      return;
    }
    if (this.isCheckOut) {
      this.isCheckIn = false;
      this.isCheckOut = false;
      const diff = moment(day.date).diff(this.checkintoday, 'd');
      if (diff < 0) {
        event.preventDefault();
        this.setDateIfInvalid(day);
        return;
      }
      this.checkOutDate = day.date._d;
      this.checkOuttoday = day.date._d;
      this.endDateModel = [];
      this.selectedDaysCheckOut = [];
      this.selectedDaysCheckOut.push(day.date);
      this.endDateModel = day.date;
      this.validateDateAndTime(this.startDateModel, this.endDateModel);
      this.dateSelectedMonthCheckout = moment(this.endDateModel, 'months', true);
      setTimeout(() => {
        if (this.multipleDatePicker && typeof (this.multipleDatePicker as any).runGenerate === 'function') {
          this.multipleDatePicker.runGenerate();
        }
        if (typeof $ !== 'undefined' && $('.tpl ul li.active').length > 0) {
          $('.tpl').animate({ scrollTop: $('.tpl ul li.active').position().top - $('.tpl ul').position().top });
        }
      }, 200);
    }
    if (typeof $ !== 'undefined' && $('.tpl ul li.active').length > 0) {
      $('.tpl').animate({ scrollTop: $('.tpl ul li.active').position().top - $('.tpl ul').position().top });
    }
  };

  setDateIfInvalid(day: any) {
    this.isCheckIn = false;
    this.isCheckOut = false;
    this.checkInDate = day.date._d;
    this.checkintoday = day.date._d;
    this.checkOutDate = day.date._d;
    this.checkOuttoday = day.date._d;
    this.selectedDays = [];
    this.selectedDays.push(day.date);
    this.selectedDaysCheckOut = [];
    this.selectedDaysCheckOut.push(day.date);
    this.startDateModel = day.date;
    this.endDateModel = day.date;
    this.dateSelectedMonth = moment(this.startDateModel, 'months', true);
    this.dateSelectedMonthCheckout = moment(this.endDateModel, 'months', true);
    this.validateDateAndTime(this.startDateModel, this.endDateModel);
  }

  validateDateAndTime(startDate: any, endDate: any) {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    this.errorMessage = '';
    this.endTimeArray = this.timeArray;
    if (date1 < date2) {
      // valid
    } else if (date1 > date2) {
      this.errorMessage = 'Please select valid Checkin Date and Checkout Date.';
    } else {
      const startTimeIndex = this.timeArray.findIndex((time: any) => time.value === this.selectedStartTime);
      const endTimeIndex = this.timeArray.findIndex((time: any) => time.value === this.selectedEndTime);
      if (startTimeIndex > endTimeIndex || startTimeIndex === endTimeIndex) {
        const nextEndTimeIndex = startTimeIndex + 1;
        if (nextEndTimeIndex < this.timeArray.length) {
          this.selectedEndTime = this.timeArray[nextEndTimeIndex].value;
          this.selectedEndTimeToShow = this.getDsplyByValue(this.timeArray[nextEndTimeIndex].value);
        }
      }
      this.endTimeArray = this.timeArray.slice(startTimeIndex + 1);
    }
  }

  isCheckIn: boolean = false;
  isCheckOut: boolean = false;

  openCalender(type: string) {
    setTimeout(() => {
      if (type === 'from') {
        this.isCheckOut = false;
        this.isCheckIn = !this.isCheckIn;
      } else if (type === 'to') {
        this.isCheckIn = false;
        this.isCheckOut = !this.isCheckOut;
      }
    }, 100);
  }

  serverCurrentDate: any;

  onDateTimeRespond() {
    const date = moment(moment.tz(moment(this.startDate), this.timeZone).format('YYYY-MM-DD HH:mm:ss'));
    this.today = moment(moment.tz(moment(this.startDate), this.timeZone));
    this.startDateModel = [];
    this.selectedDays = [];
    this.startDateModel = date;
    this.selectedDays.push(date);
    this.dateSelectedMonth = moment(date, 'months', true);

    const dateCkout = moment(moment.tz(moment(this.endDate), this.timeZone).format('YYYY-MM-DD HH:mm:ss'));
    this.today = moment(moment.tz(moment(this.endDate), this.timeZone));
    this.endDateModel = [];
    this.selectedDaysCheckOut = [];
    this.endDateModel = dateCkout;
    this.selectedDaysCheckOut.push(dateCkout);
    this.dateSelectedMonthCheckout = moment(dateCkout, 'months', true);
    this.validateDateAndTime(this.startDateModel, this.endDateModel);
    setTimeout(() => {
      if (this.multipleDatePicker && typeof (this.multipleDatePicker as any).runGenerate === 'function') {
        this.multipleDatePicker.runGenerate();
      }
    }, 200);

    this.checkintoday = date;
    this.checkOuttoday = dateCkout;
    this.checkInDate = date;
    this.checkOutDate = dateCkout;
  }

  public timeArray = [
    { value: '00:00:00', dsply: '12:00 AM' },
    { value: '00:15:00', dsply: '12:15 AM' },
    { value: '00:30:00', dsply: '12:30 AM' },
    { value: '00:45:00', dsply: '12:45 AM' },
    { value: '01:00:00', dsply: '1:00 AM' },
    { value: '01:15:00', dsply: '1:15 AM' },
    { value: '01:30:00', dsply: '1:30 AM' },
    { value: '01:45:00', dsply: '1:45 AM' },
    { value: '02:00:00', dsply: '2:00 AM' },
    { value: '02:15:00', dsply: '2:15 AM' },
    { value: '02:30:00', dsply: '2:30 AM' },
    { value: '02:45:00', dsply: '2:45 AM' },
    { value: '03:00:00', dsply: '3:00 AM' },
    { value: '03:15:00', dsply: '3:15 AM' },
    { value: '03:30:00', dsply: '3:30 AM' },
    { value: '03:45:00', dsply: '3:45 AM' },
    { value: '04:00:00', dsply: '4:00 AM' },
    { value: '04:15:00', dsply: '4:15 AM' },
    { value: '04:30:00', dsply: '4:30 AM' },
    { value: '04:45:00', dsply: '4:45 AM' },
    { value: '05:00:00', dsply: '5:00 AM' },
    { value: '05:15:00', dsply: '5:15 AM' },
    { value: '05:30:00', dsply: '5:30 AM' },
    { value: '05:45:00', dsply: '5:45 AM' },
    { value: '06:00:00', dsply: '6:00 AM' },
    { value: '06:15:00', dsply: '6:15 AM' },
    { value: '06:30:00', dsply: '6:30 AM' },
    { value: '06:45:00', dsply: '6:45 AM' },
    { value: '07:00:00', dsply: '7:00 AM' },
    { value: '07:15:00', dsply: '7:15 AM' },
    { value: '07:30:00', dsply: '7:30 AM' },
    { value: '07:45:00', dsply: '7:45 AM' },
    { value: '08:00:00', dsply: '8:00 AM' },
    { value: '08:15:00', dsply: '8:15 AM' },
    { value: '08:30:00', dsply: '8:30 AM' },
    { value: '08:45:00', dsply: '8:45 AM' },
    { value: '09:00:00', dsply: '9:00 AM' },
    { value: '09:15:00', dsply: '9:15 AM' },
    { value: '09:30:00', dsply: '9:30 AM' },
    { value: '09:45:00', dsply: '9:45 AM' },
    { value: '10:00:00', dsply: '10:00 AM' },
    { value: '10:15:00', dsply: '10:15 AM' },
    { value: '10:30:00', dsply: '10:30 AM' },
    { value: '10:45:00', dsply: '10:45 AM' },
    { value: '11:00:00', dsply: '11:00 AM' },
    { value: '11:15:00', dsply: '11:15 AM' },
    { value: '11:30:00', dsply: '11:30 AM' },
    { value: '11:45:00', dsply: '11:45 AM' },
    { value: '12:00:00', dsply: '12:00 PM' },
    { value: '12:15:00', dsply: '12:15 PM' },
    { value: '12:30:00', dsply: '12:30 PM' },
    { value: '12:45:00', dsply: '12:45 PM' },
    { value: '13:00:00', dsply: '1:00 PM' },
    { value: '13:15:00', dsply: '1:15 PM' },
    { value: '13:30:00', dsply: '1:30 PM' },
    { value: '13:45:00', dsply: '1:45 PM' },
    { value: '14:00:00', dsply: '2:00 PM' },
    { value: '14:15:00', dsply: '2:15 PM' },
    { value: '14:30:00', dsply: '2:30 PM' },
    { value: '14:45:00', dsply: '2:45 PM' },
    { value: '15:00:00', dsply: '3:00 PM' },
    { value: '15:15:00', dsply: '3:15 PM' },
    { value: '15:30:00', dsply: '3:30 PM' },
    { value: '15:45:00', dsply: '3:45 PM' },
    { value: '16:00:00', dsply: '4:00 PM' },
    { value: '16:15:00', dsply: '4:15 PM' },
    { value: '16:30:00', dsply: '4:30 PM' },
    { value: '16:45:00', dsply: '4:45 PM' },
    { value: '17:00:00', dsply: '5:00 PM' },
    { value: '17:15:00', dsply: '5:15 PM' },
    { value: '17:30:00', dsply: '5:30 PM' },
    { value: '17:45:00', dsply: '5:45 PM' },
    { value: '18:00:00', dsply: '6:00 PM' },
    { value: '18:15:00', dsply: '6:15 PM' },
    { value: '18:30:00', dsply: '6:30 PM' },
    { value: '18:45:00', dsply: '6:45 PM' },
    { value: '19:00:00', dsply: '7:00 PM' },
    { value: '19:15:00', dsply: '7:15 PM' },
    { value: '19:30:00', dsply: '7:30 PM' },
    { value: '19:45:00', dsply: '7:45 PM' },
    { value: '20:00:00', dsply: '8:00 PM' },
    { value: '20:15:00', dsply: '8:15 PM' },
    { value: '20:30:00', dsply: '8:30 PM' },
    { value: '20:45:00', dsply: '8:45 PM' },
    { value: '21:00:00', dsply: '9:00 PM' },
    { value: '21:15:00', dsply: '9:15 PM' },
    { value: '21:30:00', dsply: '9:30 PM' },
    { value: '21:45:00', dsply: '9:45 PM' },
    { value: '22:00:00', dsply: '10:00 PM' },
    { value: '22:15:00', dsply: '10:15 PM' },
    { value: '22:30:00', dsply: '10:30 PM' },
    { value: '22:45:00', dsply: '10:45 PM' },
    { value: '23:00:00', dsply: '11:00 PM' },
    { value: '23:15:00', dsply: '11:15 PM' },
    { value: '23:30:00', dsply: '11:30 PM' },
    { value: '23:45:00', dsply: '11:45 PM' }
  ];
}
